<div class="alert-center-page">
  <div class="alert-center-wrapper">
    @if (!isChildRouteActive) {
      @if (selectedAlert) {
        <app-alert-form
          [alert]="selectedAlert"
          [title]="alertTypeMap[selectedAlert.alertType].name"
          [description]="alertTypeMap[selectedAlert.alertType].description"
          [myBrandsAndCompetitors]="myBrandsAndCompetitors"
          (exit)="closeAlertForm($event)">
        </app-alert-form>
      } @else {
        <div class="alert-center-container">
          <div class="header">
            <div class="header-title-container">
              <div class="header-icon"><img [src]="'svg/bell.svg' | assetVersion"></div>
              <span class="header-title">Alert Center</span>
            </div>
            <span class="header-description">Select an alert to configure and start receiving notifications</span>
          </div>
          @if (alertSubscriptions) {
            <div class="alerts-list">
              @for (alert of alertSubscriptions.alerts; track alert) {
                <div class="alert-item">
                  <div class="alert-header">
                    <span class="alert-title">{{ alertTypeMap[alert.alertType].name }}</span>
                    <span class="alert-description">{{ alertTypeMap[alert.alertType].description }}</span>
                  </div>
                  <div class="alert-config">
                    <button class="edit" (click)="openAlertForm(alert)">Edit</button>
                    <app-toggle-switch [enabled]="alert.enabled" (toggled)="toggleAlert(alert, $event)"></app-toggle-switch>
                  </div>
                </div>
              }
              <!-- coming soon -->
              <div class="alert-item">
                <div class="alert-header">
                  <span class="alert-title">Competitor Campaigns</span>
                  <span class="alert-description">Monitor your competitors for newly launched campaigns</span>
                </div>
                <span class="coming-soon">Coming Soon</span>
              </div>
              <!-- coming soon -->
              <div class="alert-item">
                <div class="alert-header">
                  <span class="alert-title">New Competitor</span>
                  <span class="alert-description">Monitor significant changes in campaign performance metrics</span>
                </div>
                <span class="coming-soon">Coming Soon</span>
              </div>
            </div>
          } @else {
            <div class="no-alerts-message">
              @if (loading) {
                <app-loader [overlayBackgroundColor]="'transparent'"></app-loader>
              } @else {
                <span class="message-text">Unable to load your alerts.</span>
                <span class="message-text">Please try again in a moment.</span>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
